var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRiskGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 6.25012L8.83325 8.75012L12.1666 10.4168L9.66659 12.9168M17.1666 10.0001C17.1666 14.0905 12.705 17.0654 11.0816 18.0125C10.8971 18.1201 10.8048 18.174 10.6747 18.2019C10.5736 18.2235 10.4262 18.2235 10.3252 18.2019C10.195 18.174 10.1028 18.1201 9.91826 18.0125C8.29489 17.0654 3.83325 14.0905 3.83325 10.0001V6.01478C3.83325 5.34852 3.83325 5.01539 3.94222 4.72904C4.03848 4.47607 4.1949 4.25035 4.39797 4.07139C4.62783 3.86882 4.93975 3.75185 5.56359 3.51791L10.0318 1.84234C10.205 1.77738 10.2916 1.74489 10.3807 1.73202C10.4598 1.72059 10.5401 1.72059 10.6191 1.73202C10.7082 1.74489 10.7948 1.77738 10.9681 1.84234L15.4362 3.51791C16.0601 3.75185 16.372 3.86882 16.6019 4.07139C16.8049 4.25035 16.9614 4.47607 17.0576 4.72904C17.1666 5.01539 17.1666 5.34852 17.1666 6.01478V10.0001Z",
    stroke: "#A7A7A7",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskGray);
export default __webpack_public_path__ + "static/media/risk-gray.3b5959fd517f15368563b15ca165e123.svg";
export { ForwardRef as ReactComponent };